export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70f83d45dd68f110bc9253d3458183e24322311749&name=pushAdClickData!'